"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const useStore_1 = require("../../store/useStore");
const lucide_react_1 = require("lucide-react");
require("./InviteModal.css");
const InviteModal = () => {
    const { pendingInviteCode, setPendingInviteCode, joinByInvite, currentUser } = (0, useStore_1.useStore)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [joining, setJoining] = (0, react_1.useState)(false);
    const [joined, setJoined] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [serverInfo, setServerInfo] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!pendingInviteCode) {
            setServerInfo(null);
            setError(null);
            setJoined(false);
            return;
        }
        const fetchPreview = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await fetch(`${useStore_1.API_BASE_URL}/servers/invite-preview?code=${encodeURIComponent(pendingInviteCode)}`, { credentials: 'include' });
                if (response.ok) {
                    const data = await response.json();
                    setServerInfo(data);
                    if (data.is_banned) {
                        setJoined(false);
                    }
                    else if (data.is_member) {
                        setJoined(true);
                    }
                }
                else {
                    const data = await response.json();
                    setError(data.error || 'Davet kodu geçersiz.');
                }
            }
            catch {
                setError('Sunucuya bağlanılamadı.');
            }
            finally {
                setLoading(false);
            }
        };
        fetchPreview();
    }, [pendingInviteCode]);
    if (!pendingInviteCode)
        return null;
    const handleJoin = async () => {
        setJoining(true);
        setError(null);
        try {
            await joinByInvite(pendingInviteCode);
            setJoined(true);
            // Auto-close after brief success display
            setTimeout(() => {
                setPendingInviteCode(null);
            }, 1500);
        }
        catch (err) {
            setError(err.message || 'Katılım başarısız oldu.');
        }
        finally {
            setJoining(false);
        }
    };
    const handleClose = () => {
        setPendingInviteCode(null);
    };
    const getServerIcon = () => {
        if (serverInfo?.icon) {
            const iconUrl = serverInfo.icon.startsWith('http')
                ? serverInfo.icon
                : `https://meci.teymensel.com/uploads/${serverInfo.icon}`;
            return (0, jsx_runtime_1.jsx)("img", { src: iconUrl, alt: serverInfo.name, className: "invite-server-icon-img" });
        }
        if (serverInfo?.name) {
            return (0, jsx_runtime_1.jsx)("span", { className: "invite-server-icon-letter", children: serverInfo.name.charAt(0).toUpperCase() });
        }
        return (0, jsx_runtime_1.jsx)("span", { className: "invite-server-icon-letter", children: "?" });
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "invite-modal-overlay", onClick: handleClose, children: (0, jsx_runtime_1.jsxs)("div", { className: "invite-modal", onClick: (e) => e.stopPropagation(), children: [(0, jsx_runtime_1.jsx)("button", { className: "invite-close-btn", onClick: handleClose, children: (0, jsx_runtime_1.jsx)(lucide_react_1.X, { size: 20 }) }), (0, jsx_runtime_1.jsxs)("div", { className: "invite-banner", children: [(0, jsx_runtime_1.jsx)("div", { className: "invite-banner-particles", children: Array.from({ length: 12 }).map((_, i) => ((0, jsx_runtime_1.jsx)("div", { className: `particle particle-${i}` }, i))) }), (0, jsx_runtime_1.jsx)("div", { className: "invite-banner-gradient" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "invite-server-icon-wrapper", children: [(0, jsx_runtime_1.jsx)("div", { className: "invite-server-icon", children: loading ? (0, jsx_runtime_1.jsx)(lucide_react_1.Loader2, { size: 28, className: "animate-spin" }) : getServerIcon() }), serverInfo && !loading && ((0, jsx_runtime_1.jsx)("div", { className: "invite-online-badge" }))] }), (0, jsx_runtime_1.jsx)("div", { className: "invite-content", children: loading ? ((0, jsx_runtime_1.jsxs)("div", { className: "invite-loading", children: [(0, jsx_runtime_1.jsx)("div", { className: "invite-skeleton invite-skeleton-title" }), (0, jsx_runtime_1.jsx)("div", { className: "invite-skeleton invite-skeleton-desc" }), (0, jsx_runtime_1.jsx)("div", { className: "invite-skeleton invite-skeleton-meta" })] })) : error ? ((0, jsx_runtime_1.jsxs)("div", { className: "invite-error-state", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.AlertCircle, { size: 48, color: "#ef4444" }), (0, jsx_runtime_1.jsx)("h3", { children: "Kat\u0131l\u0131m Engellendi" }), (0, jsx_runtime_1.jsx)("p", { children: error }), (0, jsx_runtime_1.jsx)("button", { className: "invite-btn invite-btn-secondary", onClick: handleClose, children: "Kapat" })] })) : serverInfo ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "invite-subtitle", children: "Bir sunucuya davet edildiniz" }), (0, jsx_runtime_1.jsx)("h2", { className: "invite-server-name", children: serverInfo.name }), serverInfo.description && ((0, jsx_runtime_1.jsx)("p", { className: "invite-server-desc", children: serverInfo.description })), (0, jsx_runtime_1.jsxs)("div", { className: "invite-meta-row", children: [(0, jsx_runtime_1.jsxs)("div", { className: "invite-meta-item", children: [(0, jsx_runtime_1.jsx)("div", { className: "invite-meta-dot invite-meta-dot-online" }), (0, jsx_runtime_1.jsx)("span", { children: "\u00C7evrimi\u00E7i" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "invite-meta-item", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Users, { size: 14 }), (0, jsx_runtime_1.jsxs)("span", { children: [serverInfo.member_count.toLocaleString('tr-TR'), " \u00FCye"] })] }), serverInfo.owner_name && ((0, jsx_runtime_1.jsxs)("div", { className: "invite-meta-item", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Crown, { size: 14 }), (0, jsx_runtime_1.jsx)("span", { children: serverInfo.owner_name })] }))] }), serverInfo.is_banned ? ((0, jsx_runtime_1.jsxs)("div", { className: "invite-error-state", style: { padding: '12px 0 0', margin: 0 }, children: [(0, jsx_runtime_1.jsxs)("div", { style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            padding: '12px 16px',
                                            background: 'rgba(239, 68, 68, 0.15)',
                                            border: '1px solid rgba(239, 68, 68, 0.3)',
                                            borderRadius: '10px',
                                            color: '#f87171',
                                            fontWeight: 600,
                                            fontSize: '14px',
                                            width: '100%',
                                            marginBottom: '12px'
                                        }, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.AlertCircle, { size: 18 }), (0, jsx_runtime_1.jsx)("span", { children: "Bu sunucudan yasakland\u0131n\u0131z!" })] }), serverInfo.ban_reason && ((0, jsx_runtime_1.jsxs)("p", { style: { fontSize: '13px', color: '#94a3b8', margin: '0 0 12px' }, children: ["Sebep: ", (0, jsx_runtime_1.jsx)("strong", { style: { color: '#cbd5e1' }, children: serverInfo.ban_reason })] })), (0, jsx_runtime_1.jsx)("button", { className: "invite-btn invite-btn-secondary", style: { width: '100%' }, onClick: handleClose, children: "Kapat" })] })) : joined ? ((0, jsx_runtime_1.jsxs)("div", { className: "invite-success", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.CheckCircle, { size: 20 }), (0, jsx_runtime_1.jsx)("span", { children: "Zaten bu sunucunun \u00FCyesisin!" })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: "invite-actions", children: [(0, jsx_runtime_1.jsx)("button", { className: "invite-btn invite-btn-secondary", onClick: handleClose, disabled: joining, children: "\u0130ptal" }), (0, jsx_runtime_1.jsx)("button", { className: "invite-btn invite-btn-primary", onClick: handleJoin, disabled: joining || !currentUser, children: joining ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Loader2, { size: 16, className: "animate-spin" }), "Kat\u0131l\u0131n\u0131yor..."] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Sunucuya Kat\u0131l", (0, jsx_runtime_1.jsx)(lucide_react_1.ArrowRight, { size: 16 })] })) })] }))] })) : null })] }) }));
};
exports.InviteModal = InviteModal;
